<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 查询条件区 + 操作按钮 -->
            <div class="search-bar">
                <el-select v-model="queryCon.devType" placeholder="设备分类" style="width: 160px">
                    <el-option label="所有" :value="-1" />
                    <el-option v-for="item in deviceTypes" :key="item.id" :label="item.dicLabel" :value="item.dicVal" />
                </el-select>
                <el-input v-model="queryCon.devModel" placeholder="型号代码" style="width: 200px" />
                <el-button-group>
                    <el-button type="primary" :icon="Search" @click="handler.queryHandler">查询</el-button>
                    <el-button :icon="RefreshRight" @click="resetQueryCon">重置</el-button>
                </el-button-group>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id" class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }" ref="dataTableRef">
        <el-table-column type="selection" width="40" />
        <el-table-column prop="devModel" label="型号代码" width="180" />
        <el-table-column prop="devTypeName" label="设备分类" width="160" />
        <el-table-column prop="devName" label="型号及名称" width="220">
            <template #default="scope">
                <div>型号：{{ scope.row.devName }}</div>
                <div>代码：{{ scope.row.devModel}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="devModelSupplier" label="供应商信息" >
            <template #default="scope">
                <div>供应商：{{ scope.row.supplierName }}</div>
                <div>供应商型号：{{ scope.row.devModelSupplier}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="devChannelCount" label="控制路数" width="100" />
        <el-table-column prop="modifyName" label="修改人" width="100" />
        <el-table-column prop="modifyDate" label="修改日期" width="180">
            <template #default="scope">
                <span>{{ utils.formatDate(scope.row.modifyDate, "YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="110" header-align="center" fixed="right">
            <template #default="scope">
                <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
            </template>
        </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
                    :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next"
                    :total="pagination.pageInfo.total" @size-change="pagination.handleSizeChange"
                    @current-change="pagination.handleCurrentChange" />
            </div>
        </el-card>

    <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="800">
        <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
            ref="dataFormRef">
            <el-form-item v-show="false" label="id" prop="id">
                <el-input v-model="form.id"></el-input>
            </el-form-item>
            <el-form-item label="设备分类" prop="devType">
                <el-select v-model="form.devType" placeholder="请选择设备类型" class="el-input-width">
                    <el-option v-for="item in deviceTypes" :key="item.dicLabel" :label="item.dicLabel"
                        :value="item.dicVal" />
                </el-select>
            </el-form-item>
            <el-form-item label="型号代码" prop="devModel">
                <el-input v-model="form.devModel" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="供应商" prop="supplierId">
                <el-select v-model="form.supplierId" placeholder="请选择供应商" class="el-input-width">
                    <el-option v-for="item in suppliers" :key="item.supplierName" :label="item.supplierName"
                        :value="item.id">
                        <span style="float: left;font-size: 13px;margin-right:20px;">{{ item.supplierName }}</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 12px;">
                            {{ item.supplierAddress }}
                        </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商设备型号" prop="devModelSupplier">
                <el-input v-model="form.devModelSupplier" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="设备名称" prop="devName">
                <el-input v-model="form.devName" autocomplete="off" class="el-input-width" />
            </el-form-item>
            <el-form-item label="输出/控制路数" prop="devModelOuts">
                <el-input-number v-model="form.devChannelCount" :min="0" :max="100" class="el-input-width" />
            </el-form-item>
            <el-form-item label="设备功能" prop="devModelFun">
                <el-input v-model="form.devModelFun" autocomplete="off" type="textarea" style="width:580px;" />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:580px;" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="handler.saveHandler">保存</el-button>
            </div>
        </template>
    </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import '../../../src/assets/styles/common.css';

:deep(.my-label) {
    background: var(--el-color-success-light-9) !important;
}
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from 'vue';
import { ElTable, ElMessageBox, ElMessage, ElSelect, ElOption } from 'element-plus';
import { Delete, CirclePlusFilled, Search, Edit, RefreshRight } from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import "@/assets/styles/crud-page.css";
import utils from "@/utils/utils";
import { sprintf } from 'sprintf-js';
import { deviceModelApi } from "@/api/deviceApi.js";
import { supplierApi } from "@/api/supplierApi.js";
import { dictionaryApi } from "@/api/dict-api";

//查询条件
const queryCon = reactive({
    devType: -1,
    devModel: '',
    pageSize: 10,
    currentPage: 1
})


const resetQueryCon = function () {
    queryCon.devType = -1;
    queryCon.devModel = "";
    queryCon.pageSize = 10,
        queryCon.currentPage = 1;
};

//表单对象
const form = reactive({
    id: '',
    devType: null,
    devModel: '',
    devModelSupplier: null,
    devName: '',
    devChannelCount: 1,
    devModelFun: '',
    remark: '',
    supplierId: null
});

//分页处理
const pagination = {
    pageInfo: reactive({
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
    }),
    handleSizeChange: (val) => {
        queryCon.pageSize = val;
        handler.queryHandler();
    },
    handleCurrentChange: (val) => {
        queryCon.currentPage = val;
        handler.queryHandler();
    }
}

const rules = {
    devType: [{ required: true, message: '', trigger: 'blur' }],
    devModel: [{ required: true, message: '', trigger: 'blur' }],
    devModelSupplier: [{ required: true, message: '', trigger: 'blur' }],
    devName: [{ required: true, message: '', trigger: 'blur' }],
    supplierId: [{ required: true, message: '', trigger: 'blur' }]
};

//弹出框状态
const dialogFormVisible = ref(false);
const tableLoading = ref(false);
const tableData = ref([]);
const suppliers = ref([]);
const deviceTypes = ref([]);
//引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);

async function init() {
    //加载设备类型选项
    deviceTypes.value = await dictionaryApi.listDict(dictionaryApi.deviceType);

    //供应商
    const supplierData = await supplierApi.queryList({ supplierName: '' });
    suppliers.value = supplierData.data.result;
}

//生命周期
onMounted(async () => {
    tableLoading.value = true;
    await init();
    handler.queryHandler();
});

const resetForm = () => {
    dataFormRef.value?.resetFields();
};

//UI界面逻辑
const handler = {
    queryHandler() {
        deviceModelApi.query(queryCon).then((response) => {
            if (response.data.errorCode === "00000") {
                tableData.value = response.data.result.records;
                pagination.pageInfo.total = response.data.result.total;
            } else {
                ElMessage.error(sprintf("操作失败，%s, [错误码:%s]",
                    response.data.errorMessage,
                    response.data.errorCode));
            }
        })
            .finally(function () {
                tableLoading.value = false;
            });
    },
    addHandler() {
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
        })
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm(
            '确认要删除吗?',
            'Warning',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                deviceModelApi.delete([rowObj.id])
                    .then((response) => {
                        if (response.data.errorCode === "00000") {
                            ElMessage({ message: '删除成功.', type: 'success' });
                            handler.queryHandler();
                            this.dialogFormVisible = false;
                        } else {
                            ElMessage.error(sprintf("操作失败，%s, [错误码:%s]",
                                response.data.errorMessage,
                                response.data.errorCode));
                        }
                    })
            })
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) { ElMessage("没有选中任何行"); return; }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm(
            '确认要删除吗?',
            'Warning',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                deviceModelApi.delete(ids)
                    .then((response) => {
                        if (response.data.errorCode === "00000") {
                            ElMessage({ message: '删除成功.', type: 'success' });
                            handler.queryHandler();
                            this.dialogFormVisible = false;
                        } else {
                            ElMessage.error(sprintf("操作失败，%s, [错误码:%s]",
                                response.data.errorMessage,
                                response.data.errorCode));
                        }
                    })
            })
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                deviceModelApi.save(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '保存成功', type: 'success' });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error(sprintf("操作失败，%s, [错误码:%s]",
                            response.data.errorMessage,
                            response.data.errorCode));
                    }
                })
            }
        });
    }
}
</script>